import Button from 'components/button'
import { useRef } from 'react'
import { Checkbox, DivCheckbox, Label, PCheckbox } from 'theme/theme'
import Input from 'components/input'
import textServices from 'services/text-services'
import useMainClass from 'hooks/use-main-cass'

const WifiForm = ({
  nameRef = useRef<any>(null),
  phoneRef = useRef<any>(null),
  emailRef = useRef<any>(null),
  termsOfUse = { value: false, setValue: (bool: boolean) => console.log(bool) },
  privacyNotice = { value: false, setValue: (bool: boolean) => console.log(bool) },
  subscribe = { value: false, setValue: (bool: boolean) => console.log(bool) }
}) => {
  useMainClass('wifi__auth__form')

  return (
    <div className="px-4 pt-4 pb-9 flex-1 flex flex-col w-full">
      <div className="flex-1 flex flex-col content-wrapper">
        <div className="w-full">
          <img className="mx-auto" src={`${AZURE_BASE_URL}/wifi-home.webp`} alt="Wifi" />
        </div>
        <h2 className="text-center title small wifi__title">Completa los datos para ingresar</h2>
        <div className="flex-1 flex flex-col gap-4">
          <div className="gap-2 flex flex-col input-container">
            <Label className="text-start text-2xl font-bold uppercase input-label">Nombre</Label>
            <Input
              type="text"
              required
              placeholder="Roberto"
              className="text-center saira font-bold text-sm"
              ref={nameRef}
            />
          </div>
          <div className="gap-2 flex flex-col input-container">
            <Label className="text-start text-2xl font-bold uppercase input-label">Correo electrónico</Label>
            <Input
              type="email"
              required
              placeholder="Roberto@mail.com"
              className="text-center saira font-bold text-sm"
              name="username"
              id="username"
              ref={emailRef}
            />
          </div>
          <div className="gap-2 flex flex-col input-container">
            <Label className="text-start text-2xl font-bold uppercase input-label">Número de celular</Label>
            <Input
              type="tel"
              required
              pattern="[0-9]{10}"
              title="Debe contener 10 dígitos"
              placeholder="123456789"
              className="text-center saira font-bold text-sm"
              name="password"
              id="password"
              ref={phoneRef}
            />
          </div>
        </div>
      </div>
      <div className="flex w-full flex-col px-[16px] justify-center items-center mt-10 gap-4">
        <DivCheckbox
          className="gap-4 w-full flex items-center cursor-pointer input-container"
          onClick={() => termsOfUse?.setValue(!termsOfUse?.value)}
        >
          <Checkbox active={termsOfUse?.value} className={`h-6 w-6 flex items-center justify-center`} id="termsOfUse" />
          <PCheckbox className="dinPro input-checkbox-label flex-1">
            {textServices.findByText('signup/termsOfUse/label', {
              es: (
                <>
                  Acepto los{' '}
                  <a
                    href={`${process.env.PUBLIC_URL}/terms-and-conditions`}
                    rel="noreferrer"
                    target="_blank"
                    className="underline"
                  >
                    Términos y Condiciones
                  </a>
                  .
                </>
              ),
              en: (
                <>
                  I accept the{' '}
                  <a
                    href={`${process.env.PUBLIC_URL}/terms-and-conditions`}
                    rel="noreferrer"
                    target="_blank"
                    className="underline"
                  >
                    Terms and Conditions
                  </a>
                  .
                </>
              )
            })}
          </PCheckbox>
        </DivCheckbox>

        <DivCheckbox
          className="gap-4 w-full flex items-center cursor-pointer input-container"
          onClick={() => privacyNotice?.setValue(!privacyNotice?.value)}
        >
          <Checkbox
            active={privacyNotice?.value}
            className={`h-6 w-6 flex items-center justify-center`}
            id="privacyNotice"
          />
          <PCheckbox className="dinPro input-checkbox-label flex-1">
            {textServices.findByText('signup/privacyPolicy/label', {
              es: (
                <>
                  Acepto los{' '}
                  <a
                    href={`${process.env.PUBLIC_URL}/privacy-politics`}
                    rel="noreferrer"
                    target="_blank"
                    className="underline"
                  >
                    Aviso de privacidad
                  </a>
                  .
                </>
              ),
              en: (
                <>
                  I accept the{' '}
                  <a
                    href={`${process.env.PUBLIC_URL}/privacy-politics`}
                    rel="noreferrer"
                    target="_blank"
                    className="underline"
                  >
                    Privacy Policy
                  </a>
                  .
                </>
              )
            })}
          </PCheckbox>
        </DivCheckbox>
        <DivCheckbox
          className="gap-4 w-full flex items-center cursor-pointer input-container"
          onClick={() => subscribe?.setValue(!subscribe?.value)}
        >
          <Checkbox className={`h-6 w-6 flex items-center justify-center`} id="suscribe" active={subscribe?.value} />
          <PCheckbox className="dinPro input-checkbox-label flex-1">
            {textServices.findByText('signup/suscribe/label', {
              es: (
                <>
                  Tu privacidad es nuestra prioridad. Al &quot;Aceptar&quot;, nos das tu consentimiento para procesar
                  tus datos personales con el fin de mejorar tu experiencia y ofrecerte contenido personalizado. En
                  cualquier momento, puedes gestionar o retirar tu consentimiento accediendo a tu <b>Preference Center</b> o a
                  través de los medios que ponemos a tu disposición en el{' '}
                  <a
                    href={`${process.env.PUBLIC_URL}/privacy-politics`}
                    rel="noreferrer"
                    target="_blank"
                    className="underline"
                  >
                    Aviso de Privacidad
                  </a>
                  .
                </>
              ),
              en: (
                <>
                  Your privacy is our priority. By &quot;Accepting&quot;, you give us your consent to process your
                  personal data in order to improve your experience and offer you personalized content. At any time, you
                  can manage or withdraw your consent by accessing your <b>Preference Center</b> or through the means we make
                  available to you in the{' '}
                  <a
                    href={`${process.env.PUBLIC_URL}/privacy-politics`}
                    rel="noreferrer"
                    target="_blank"
                    className="underline"
                  >
                    Privacy Notice
                  </a>
                  .
                </>
              )
            })}
          </PCheckbox>
        </DivCheckbox>
        <Button disabled={!(termsOfUse?.value && privacyNotice?.value)}>CONECTAR</Button>
      </div>
    </div>
  )
}

export default WifiForm
